<template>
  <div>
    <b-form-group v-bind:label="Datafield.label" v-bind:description="Datafield.label">
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="date" required v-bind:name="Datafield.name"  v-bind:placeholder="Datafield.label" v-model="Datadata"></b-form-input>
    </b-input-group>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'inputDate',
  props: {
    field: { required: true },
    data: { required: true }
  },
  data: function () {
    return {
      Datafield: {},
      Datadata: ''
    }
  },
  mounted () {
    this.Datafield = this.field
    this.Datadata = this.data
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/form/inputDate.vue